import { node } from "~/util/dom";

type Option = { value: number, name: string };


interface IDropdownProps {
	parent: HTMLElement;
	value: number;
	options: Option[];
	timeout: number;
	width: string;
	top: string;
	background: string;
	padding: string;
	gap: string;
	onChange: (value: number) => void;
}

export default class Dropdown {
	#parent: HTMLElement;

	#dropdown: HTMLDivElement;

	#timeout: number;

	#onChange: (value: number) => void;

	value: number;

	constructor(props: IDropdownProps) {
		this.#parent = props.parent;
		this.#dropdown = node("div", { className: "ui-dropdown closed" });
		this.#timeout = props.timeout || 500;
		this.#onChange = props.onChange;
		this.value = props.value;
		for (let index = 0; index < props.options.length; index++) {
			const option = props.options[index];

			if (index !== 0) {
				const gap = node("div", { className: "ui-dropdown-option-gap" });

				this.#dropdown.appendChild(gap);
			}
			const item = node("button", { className: `ui-dropdown-option${option.value === props.value ? " active" : ""}`, innerText: option.name });

			item.dataset.value = option.value.toString();
			this.#dropdown.appendChild(item);
		}
		this.#dropdown.style.setProperty("--timeout", `${this.#timeout}ms`);
		this.#dropdown.style.setProperty("--width", props.width || "100%");
		this.#dropdown.style.setProperty("--top", props.top);
		this.#dropdown.style.setProperty("--background", props.background);
		this.#dropdown.style.setProperty("--padding", props.padding);
		this.#dropdown.style.setProperty("--gap", props.gap);
		this.#dropdown.addEventListener("click", this);
		this.#parent.appendChild(this.#dropdown);
	}

	destroy() {
		this.#dropdown.removeEventListener("click", this);
		this.#parent.removeChild(this.#dropdown);
	}

	handleEvent(event: PointerEvent) {
		const target = event.target as HTMLButtonElement;

		if (event.type === "click" && target.classList.contains("ui-dropdown-option")) {
			if (this.#dropdown.classList.contains("open")) {
				const value = Number(target.dataset.value);

				if (value !== this.value) {
					this.#dropdown.querySelector(".ui-dropdown-option.active").classList.remove("active");
					target.classList.add("active");
					this.value = value;
					this.#onChange(value);
				}
				this.#dropdown.classList.remove("open");
				setTimeout(() => {
					this.#dropdown.classList.add("closed");
				}, this.#timeout);
			} else {
				this.#dropdown.classList.remove("closed");
				this.#dropdown.classList.add("open");
			}
		}
	}
}
